import { List } from 'antd';
import { ListGridType } from 'antd/lib/list';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { InstructionDownloadFile } from './components/InstructionDownloadFile';
import { InstructionItemContainer } from './components/InstructionItemContainer';
import { InstructionItemContent } from './components/InstructionItemContent';

const GRID_OPTIONS: ListGridType = { gutter: 20, column: 4 };

/**
 * Компонент инструкицй (список карточек)
 * @constructor
 */
const Instructions: React.FC = () => {
  const { t } = useTranslation();

  const data = React.useMemo(
    () => [
      {
        children: (
          <InstructionItemContainer>
            <InstructionDownloadFile
              number={1}
              text={t('formFilling.instruction1')}
              buttonText={t('formFilling.downloadTemplate')}
            />
          </InstructionItemContainer>
        ),
      },
      {
        children: (
          <InstructionItemContainer>
            <InstructionItemContent number={2}>
              {t('formFilling.instruction2')}
            </InstructionItemContent>
          </InstructionItemContainer>
        ),
      },
      {
        children: (
          <InstructionItemContainer>
            <InstructionItemContent number={3}>
              {t('formFilling.instruction3')}
            </InstructionItemContent>
          </InstructionItemContainer>
        ),
      },
      {
        children: (
          <InstructionItemContainer>
            <InstructionItemContent number={4}>
              {t('formFilling.instruction4')}
            </InstructionItemContent>
          </InstructionItemContainer>
        ),
      },
    ],
    [t]
  );

  const handleRenderItem = React.useCallback(
    (item) => <List.Item>{item.children}</List.Item>,
    []
  );

  return (
    <List grid={GRID_OPTIONS} dataSource={data} renderItem={handleRenderItem} />
  );
};

export default React.memo(Instructions);
